<div class="modal-header">
  <h4 class="modal-title">Are you sure you want to transfer this product?</h4>
</div>
<div class="modal-body">
  <div class="email-selection-widget">
    <div class="custom-radio-box">
      <input type="radio" id="1" data-md-icheck name="transfer-type" value="1" [(ngModel)]="stockType" (ngModelChange)="onStockTypeChange()"/>
      <label for="1">Full Stock ({{size}}
        @if (uom) {
          @if (uom === constants.UNIT_OF_MEASUREMENT_SQM) {
            m<sup>2</sup>
          } @else {
            {{ uom | lowercase }}}})</label>
    </div>
    @if (showSplitStockOption) {
      <div class="split-stock-details">
        <div class="custom-radio-box">
          <input type="radio" id="2" data-md-icheck name="transfer-type" value="2" [disabled]="disableSplitStock" [(ngModel)]="stockType" (ngModelChange)="onStockTypeChange()"/>
          <label for="2">Split Stock</label>
        </div>
        @if (stockType == 2) {
          <div class="split-stock-input">
            <input type="text" class="form-control" [(ngModel)]="splitStock" (ngModelChange)="onSplitStockChange()" appDecimalInput autocomplete="off" (keypress)="checkDecimalDot($event)"/>
            <span>
               @if (uom) {
                 @if (uom === constants.UNIT_OF_MEASUREMENT_SQM) {
                   m<sup>2</sup>
                 } @else {
                   {{ uom | lowercase }}
                 }
               }
            </span>
          </div>
          @if (isQuantityTooHigh) {
            <div class="product-error-msg">Prefer quantity is greater than full stock.</div>
          }
          @if (suggestedQuantity) {
            <div class="product-error-msg"> Prefer quantity is {{ suggestedQuantity }} {{ uom }} for the selected product, <span (click)="checkQuantity()">Click Here</span> to apply it.</div>
          }
        }

        @if (submitted && !stockType) {
          <span class="stock-type-error">Select stock type</span>
        }
        @if (submitted && stockType == 2 && !splitStock) {
          <span class="stock-type-error">Enter quantity</span>
        }
        @if (submitted && splitStock && stockType == 2 && (+splitStock >= size || splitStock == 0)) {
          <span class="stock-type-error">Enter valid quantity</span>
        }
      </div>
    }
  </div>
</div>
<div class="modal-footer">
  <a class="dark-bordered-btn" href="javascript:;" data-dismiss="modal" (click)="ngbActiveModal.close()">Cancel</a>
  <button class="submit-btn-grey" type="submit" (click)="transfer()">Transfer</button>
</div>
